<template>
  <div class="wrap">
    <img src="../../assets/images/logo.png" class="logo"/>
    <div class="login-box">
      <div class="logo-head">5G云后台管理</div>
      <el-form class="form" :model="vForm" :rules="rules" ref="vForm">
        <el-form-item class="form-group" prop="username">
          <el-input class="form-control" v-model="vForm.login_name" placeholder="账号" clearable/>
        </el-form-item>
        <el-form-item class="form-group" prop="password">
          <el-input class="form-control" v-model="vForm.password" placeholder="密码" show-password/>
        </el-form-item>
        <el-form-item class="form-group" prop="vcode">
          <el-col :span="15">
            <el-input class="form-control" v-model="vForm.vcode" placeholder="验证码" clearable/>
          </el-col>
          <el-col :span="8" :offset="1">
            <img v-if="vForm.code_string" @click="refreshCaptcha" class="captcha"
              :src="codeUrl+'?code_string='+vForm.code_string">
          </el-col>
        </el-form-item>
        <div class="login-btn-box">
          <el-button @click="doLogin" class="login-btn" :loading="loading" type="primary">登录</el-button>
        </div>
      </el-form>
    </div>
    <div class="bottom-text">
      让社交更简单，让创业更轻松
    </div>
    <div class="copy-right">Powered by paojiaokeji © 2019</div>
  </div>
</template>


<script>
  import {login} from '@/api/user';
  import {generate} from '@/api/service';

  export default {
    data() {
      return {
        time: Date.now(),
        loading: false,
        codeUrl: process.env.API_BASE + '/api/service/vcode',
        vForm: {
          login_name: '',
          password: '',
          vcode: '',
          code_string: ''
        },
        rules: {
          login_name: {required: true, message: '账号不能为空', trigger: 'blur'},
          password: {required: true, message: '密码不能为空', trigger: 'blur'},
          vcode: {required: true, message: '验证码不能为空', trigger: 'blur'}
        },
        bindDoLogin: (e) => {
          if (e.keyCode == 13) {
            this.doLogin()
          }
        }
      }
    },
    created() {
      this.getCodeString();
      document.addEventListener('keydown', this.bindDoLogin)
    },
    beforeRouteLeave(to, from, next) {
      document.removeEventListener('keydown', this.bindDoLogin);
      next();
    },
    methods: {
      refreshCaptcha() {
        this.getCodeString();
      },
      async getCodeString() {
        let res = await generate();
        this.vForm.code_string = res.data.code_string;
      },
      doLogin() {
        this.$refs.vForm.validate((valid) => {
          if (valid) {
            this.loading = true;
            this.$store.dispatch('user/login', this.vForm)
                .then(() => {
                  this.loading = false;
                  this.$router.push({path: '/'});
                })
                .catch(() => {
                  this.loading = false;
                  this.getCodeString();
                })
          }
        });
      }
    }
  }

</script>


<style scoped lang="scss">


  .wrap {
    height: 100vh;
    background: white;
    background-size: cover;
    position: relative;
    .logo{
      width: 250px;
      position: absolute;
      left: 50%;
      top: 30px;
      transform: translateX(-50%);
    }
  }

  .form {
    margin: 0 0 20px 0;
  }

  .login-box {
    box-sizing: border-box;
    width: 460px;
    position: absolute;
    left: 50%;
    top: 220px;
    transform: translateX(-50%);
    background: #fff;
    padding: 0px 60px 35px 60px;
    border-radius: 4px;
    border: 1px solid #ccc;
  }

  .logo-head {
    top: -56px;
    // left: 50%;
    // margin-left: -122px;
    width: 340px;
    color: black;
    // padding: 0 50px;
    text-align: center;
    line-height: 43px;
    // background: url('../../assets/images/haed-bg.png') center center repeat-x;
    position: absolute;
    font-size: 34px;
    letter-spacing: 3px;
    font-weight: bold;
  }

  .logo-head:before {
    content: "";
    position: absolute;
    top: 0;
    left: -40px;
    height: 100%;
    width: 40px;
    // background: url('../../assets/images/haed-left.png') center center no-repeat;
  }

  .logo-head:after {
    content: "";
    position: absolute;
    top: 0;
    right: -40px;
    height: 100%;
    width: 40px;
    // background: url('../../assets/images/head-right.png') center center no-repeat;
  }

  .form-group {
    margin-top: 30px;
  }

  .login-btn-box {
    margin-top: 40px;
  }

  input::-webkit-input-placeholder {
    font-size: 14px;
    color: #cacaca;
  }

  .copy-right {
    position: absolute;
    left: 0;
    bottom: 55px;
    text-align: center;
    width: 100%;
    font-size: 24px;
    color: black;
    line-height: 36px;
  }

  .login-btn {
    display: block;
    width: 100%;
    font-size: 16px;
    letter-spacing: 6px;
  }

  .captcha {
    width: 100%;
    height: 40px;
    display: block;
  }
  .bottom-text{
    position: absolute;
    left: 0;
    bottom: 90px;
    text-align: center;
    width: 100%;
    font-size: 33px;
    color: black;
    line-height: 50px;
  }

</style>

<style>
  .login-box .form-control .el-input__inner {
    border-width: 0 0 1px 0;
    border-radius: 0;
    padding-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue